import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "./cn";

const badgeVariants = cva(
  "inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold transition-colors",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-fg",
        secondary: "bg-secondary text-secondary-fg",
        accent: "bg-accent text-accent-fg",
        success: "bg-success text-success-fg",
        warning: "bg-warning text-warning-fg",
        error: "bg-error text-error-fg",
        muted: "bg-paper text-muted border border-border",
        outline: "border border-border text-ink",
      },
    },
    defaultVariants: { variant: "default" },
  },
);

export interface BadgeProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

export function Badge({ className, variant, ...props }: BadgeProps) {
  return <span className={cn(badgeVariants({ variant }), className)} {...props} />;
}

export { badgeVariants };
